var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsideDataPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.25C3.95344 0.25 0 2.55625 0 5.5V14.5C0 17.4438 3.95344 19.75 9 19.75C14.0466 19.75 18 17.4438 18 14.5V5.5C18 2.55625 14.0466 0.25 9 0.25ZM16.5 10C16.5 10.9019 15.7612 11.8216 14.4741 12.5238C13.0247 13.3141 11.0803 13.75 9 13.75C6.91969 13.75 4.97531 13.3141 3.52594 12.5238C2.23875 11.8216 1.5 10.9019 1.5 10V8.44C3.09938 9.84625 5.83406 10.75 9 10.75C12.1659 10.75 14.9006 9.8425 16.5 8.44V10ZM3.52594 2.97625C4.97531 2.18594 6.91969 1.75 9 1.75C11.0803 1.75 13.0247 2.18594 14.4741 2.97625C15.7612 3.67844 16.5 4.59812 16.5 5.5C16.5 6.40188 15.7612 7.32156 14.4741 8.02375C13.0247 8.81406 11.0803 9.25 9 9.25C6.91969 9.25 4.97531 8.81406 3.52594 8.02375C2.23875 7.32156 1.5 6.40188 1.5 5.5C1.5 4.59812 2.23875 3.67844 3.52594 2.97625ZM14.4741 17.0238C13.0247 17.8141 11.0803 18.25 9 18.25C6.91969 18.25 4.97531 17.8141 3.52594 17.0238C2.23875 16.3216 1.5 15.4019 1.5 14.5V12.94C3.09938 14.3463 5.83406 15.25 9 15.25C12.1659 15.25 14.9006 14.3425 16.5 12.94V14.5C16.5 15.4019 15.7612 16.3216 14.4741 17.0238Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideDataPreview);
export default __webpack_public_path__ + "static/media/aside-data-preview.5739dc7968c8d819b2dac670314c2a8c.svg";
export { ForwardRef as ReactComponent };